'use client';

import { c as _c } from "react/compiler-runtime";
import { PlayButton, SeekButton, Time, TimeSlider } from '@vidstack/react';
import VidstackPlayer from './VidstackPlayer';
import { useState } from 'react';
import './VidstackAudioPlayer.scss';
const VidstackAudioPlayer = t0 => {
  const $ = _c(49);
  const {
    source,
    metadata,
    poster,
    volume: t1,
    muted: t2,
    isPlaying: t3,
    onPlay,
    onPause,
    onSeekRequest,
    onTimeUpdate,
    onVolumeChange,
    onError,
    onLoaded,
    onLoadStart
  } = t0;
  const volume = t1 === undefined ? 1 : t1;
  const muted = t2 === undefined ? false : t2;
  const isPlaying = t3 === undefined ? false : t3;
  const isLive = metadata?.type === "radio";
  const [playbackRate, setPlaybackRate] = useState(1);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      justifyContent: "space-between",
      backgroundColor: "#002266",
      color: "white"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== isLive || $[2] !== metadata?.title) {
    t5 = !isLive && <div style={{
      display: "flex",
      alignItems: "center",
      padding: "1rem",
      gap: "0.5rem"
    }}><h3 style={{
        fontSize: "1rem",
        fontWeight: 500,
        lineHeight: 1.5,
        margin: 0,
        color: "white"
      }}>{metadata?.title}</h3></div>;
    $[1] = isLive;
    $[2] = metadata?.title;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      padding: "1rem"
    };
    t7 = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "2rem"
    };
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== isLive) {
    t8 = !isLive && <div><SeekButton seconds={-15} style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        width: "1.75rem",
        height: "1.75rem",
        borderRadius: "50%",
        cursor: "pointer"
      }}><Backward15Icon /></SeekButton></div>;
    $[6] = isLive;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#000000ff",
      borderRadius: "50%",
      border: "1px solid #ffffff"
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      padding: "0.5rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#1f53bcb8",
      color: "#ffffff46",
      width: "3rem",
      height: "3em",
      borderRadius: "50%",
      cursor: "pointer"
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== isPlaying) {
    t11 = <div style={t9}><PlayButton style={t10}><PlayIcon isPlaying={isPlaying} /></PlayButton></div>;
    $[10] = isPlaying;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== isLive) {
    t12 = !isLive && <div><SeekButton seconds={10} style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        width: "1.75rem",
        height: "1.75rem",
        borderRadius: "50%",
        cursor: "pointer"
      }}><Forward30Icon /></SeekButton></div>;
    $[12] = isLive;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11 || $[15] !== t12 || $[16] !== t8) {
    t13 = <div style={t7}>{t8}{t11}{t12}</div>;
    $[14] = t11;
    $[15] = t12;
    $[16] = t8;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== isLive) {
    t14 = !isLive && <><div><TimeSlider.Root className="vds-time-slider vds-slider" style={{
          width: "100%",
          display: "flex",
          alignItems: "center"
        }}><TimeSlider.Track className="vds-slider-track" style={{
            backgroundColor: "#9FB5DF"
          }} /><TimeSlider.TrackFill className="vds-slider-track-fill vds-slider-track" style={{
            backgroundColor: "#ffffffff"
          }} /><TimeSlider.Progress className="vds-slider-progress vds-slider-track" style={{
            backgroundColor: "#9FB5DF"
          }} /><TimeSlider.Thumb className="vds-slider-thumb" style={{
            backgroundColor: "#9FB5DF",
            border: "2px solid #ffffffff"
          }} /></TimeSlider.Root></div><div style={{
        display: "flex",
        justifyContent: "space-between",
        color: "#92b6ffff",
        fontSize: "0.875rem"
      }}><Time className="vds-time" type="current" /><Time className="vds-time" type="duration" /></div></>;
    $[18] = isLive;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13 || $[21] !== t14) {
    t15 = <div style={t6}>{t13}{t14}</div>;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t15 || $[24] !== t5) {
    t16 = <div>{t5}{t15}</div>;
    $[23] = t15;
    $[24] = t5;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== isLive || $[27] !== playbackRate) {
    t17 = !isLive && <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0.5rem",
      borderTop: "1px solid #ffffff33"
    }}><SpeedControl initialPlaybackRate={playbackRate} onPlaybackRateChange={rate => setPlaybackRate(rate)} /></div>;
    $[26] = isLive;
    $[27] = playbackRate;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <div style={t4}>{t16}{t17}</div>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== isPlaying || $[33] !== metadata || $[34] !== muted || $[35] !== onError || $[36] !== onLoadStart || $[37] !== onLoaded || $[38] !== onPause || $[39] !== onPlay || $[40] !== onSeekRequest || $[41] !== onTimeUpdate || $[42] !== onVolumeChange || $[43] !== playbackRate || $[44] !== poster || $[45] !== source || $[46] !== t18 || $[47] !== volume) {
    t19 = <VidstackPlayer source={source} metadata={metadata} poster={poster} volume={volume} playbackRate={playbackRate} muted={muted} isPlaying={isPlaying} onPlay={onPlay} onPause={onPause} onSeekRequest={onSeekRequest} onTimeUpdate={onTimeUpdate} onVolumeChange={onVolumeChange} onError={onError} onLoaded={onLoaded} onLoadStart={onLoadStart}>{t18}</VidstackPlayer>;
    $[32] = isPlaying;
    $[33] = metadata;
    $[34] = muted;
    $[35] = onError;
    $[36] = onLoadStart;
    $[37] = onLoaded;
    $[38] = onPause;
    $[39] = onPlay;
    $[40] = onSeekRequest;
    $[41] = onTimeUpdate;
    $[42] = onVolumeChange;
    $[43] = playbackRate;
    $[44] = poster;
    $[45] = source;
    $[46] = t18;
    $[47] = volume;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
};
const SpeedControl = t0 => {
  const $ = _c(15);
  const {
    initialPlaybackRate,
    onPlaybackRateChange
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(initialPlaybackRate);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [0.5, 0.75, 1, 1.25, 1.5, 2];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const speeds = t1;
  let t2;
  if ($[1] !== onPlaybackRateChange) {
    t2 = speed => {
      setPlaybackRate(speed);
      onPlaybackRateChange(speed);
      setIsOpen(false);
    };
    $[1] = onPlaybackRateChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSpeedChange = t2;
  let t3;
  if ($[3] !== isOpen) {
    t3 = () => setIsOpen(!isOpen);
    $[3] = isOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== playbackRate || $[6] !== t3) {
    t4 = <button className="speed-trigger" onClick={t3} aria-label="Playback speed">{playbackRate}×</button>;
    $[5] = playbackRate;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleSpeedChange || $[9] !== isOpen || $[10] !== playbackRate) {
    t5 = isOpen && <div className="speed-menu">{speeds.map(speed_0 => <button key={speed_0} className={`speed-option ${playbackRate === speed_0 ? "active" : ""}`} onClick={() => handleSpeedChange(speed_0)}>{speed_0}× Speed</button>)}</div>;
    $[8] = handleSpeedChange;
    $[9] = isOpen;
    $[10] = playbackRate;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="speed-control">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const PlayIcon = t0 => {
  const $ = _c(2);
  const {
    isPlaying
  } = t0;
  if (isPlaying) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <svg className="icon" viewBox="0 0 24 24" width={20} style={{
        fill: "white"
      }}><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" /></svg>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="icon" viewBox="0 0 24 24" height={20} style={{
      fill: "white"
    }}><path d="M8 5v14l11-7z" /></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Forward30Icon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="icon" viewBox="0 0 24 24" style={{
      fill: "white"
    }}><path d="M 12.0000 23.3154 C 17.5948 23.3154 22.2455 18.6747 22.2455 13.0698 C 22.2455 9.6948 20.2523 6.6613 17.9278 4.7830 C 17.4859 4.4414 16.8191 4.5520 16.6966 4.9638 C 16.5741 5.3899 16.7394 5.8588 17.1813 6.1575 C 19.1317 7.6958 20.5277 10.2028 20.5420 13.0698 C 20.5563 17.8109 16.7309 21.6077 12.0000 21.6077 C 7.2548 21.6077 3.4723 17.8109 3.4723 13.0698 C 3.4723 9.0017 6.2644 5.6238 10.0615 4.7530 L 10.0615 6.1993 C 10.0615 6.9124 10.4606 7.0948 10.9455 6.7103 L 14.3102 4.4615 C 14.7623 4.1343 14.7766 3.6654 14.3102 3.3382 L 10.9169 1.0894 C 10.4606 0.6835 10.0615 0.8659 10.0615 1.5933 L 10.0615 3.0110 C 5.3605 3.9288 1.7544 8.1278 1.7544 13.0698 C 1.7544 18.6747 6.3906 23.3154 12.0000 23.3154 Z M 15.3047 17.2985 C 16.9720 17.2985 18.0569 15.7174 18.0569 13.3393 C 18.0569 10.9041 16.9720 9.2800 15.3047 9.2800 C 13.6231 9.2800 12.5382 10.8898 12.5382 13.3393 C 12.5382 15.7174 13.6374 17.2985 15.3047 17.2985 Z M 8.8258 17.2985 C 10.4030 17.2985 11.5451 16.3378 11.5451 14.9887 C 11.5451 14.0566 10.9025 13.2498 9.9975 13.1249 C 10.7243 12.9425 11.2379 12.1786 11.2379 11.3290 C 11.2379 10.1245 10.4030 9.2800 8.8830 9.2800 C 7.6708 9.2800 6.6574 9.9573 6.4349 10.9469 C 6.4062 11.0575 6.3919 11.1467 6.3919 11.2501 C 6.3919 11.6334 6.6359 11.8944 7.0349 11.8944 C 7.2718 11.8944 7.4514 11.7766 7.5596 11.4993 C 7.7606 10.7934 8.1596 10.4947 8.8401 10.4947 C 9.5492 10.4947 10.0414 10.9041 10.0414 11.4851 C 10.0414 12.1267 9.5492 12.5646 8.8401 12.5646 L 8.4124 12.5646 C 8.0136 12.5646 7.7978 12.8062 7.7978 13.1821 C 7.7978 13.5294 8.0279 13.7995 8.4124 13.7995 L 8.8830 13.7995 C 9.7449 13.7995 10.2800 14.2232 10.2800 14.9387 C 10.2800 15.6185 9.6803 16.1282 8.8687 16.1282 C 8.1310 16.1282 7.6273 15.7808 7.4371 15.1679 C 7.2718 14.8264 7.0779 14.6868 6.7119 14.6868 C 6.3275 14.6868 6.0547 14.9601 6.0547 15.3087 C 6.0547 15.4194 6.0690 15.5300 6.1120 15.6407 C 6.5109 16.5871 7.5953 17.2985 8.8258 17.2985 Z M 15.3047 16.0797 C 14.4142 16.0797 13.8431 15.0213 13.8431 13.3393 C 13.8431 11.5644 14.4 10.7005 15.3047 10.7005 C 16.1952 10.7005 16.7377 11.5501 16.7377 13.3393 C 16.7377 15.0213 16.1808 16.0797 15.3047 16.0797 Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Backward15Icon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="icon" viewBox="0 0 24 24" style={{
      fill: "white"
    }}><path d="M 12.0000 23.3154 C 17.5948 23.3154 22.2455 18.6747 22.2455 13.0698 C 22.2455 8.1278 18.6394 3.9288 13.9384 3.0110 L 13.9384 1.5933 C 13.9384 0.8659 13.5393 0.6835 13.0830 1.0894 L 9.6897 3.3382 C 9.2234 3.6654 9.2377 4.1343 9.6897 4.4615 L 13.0544 6.7103 C 13.5393 7.0948 13.9384 6.9124 13.9384 6.1993 L 13.9384 4.7530 C 17.7355 5.6238 20.5277 9.0017 20.5277 13.0698 C 20.5277 17.8109 16.7452 21.6077 12.0000 21.6077 C 7.2691 21.6077 3.4723 17.8109 3.4866 13.0698 C 3.5009 10.2028 4.8683 7.6958 6.8187 6.1575 C 7.2606 5.8588 7.4259 5.3899 7.3034 4.9638 C 7.1809 4.5520 6.5141 4.4414 6.0722 4.7830 C 3.4723 6.6613 1.7544 9.6948 1.7544 13.0698 C 1.7544 18.6747 6.3906 23.3154 12.0000 23.3154 Z M 9.0167 17.1881 C 9.4013 17.1881 9.6508 16.8735 9.6508 16.4952 L 9.6508 10.1568 C 9.6508 9.6448 9.4013 9.3302 9.0167 9.3302 C 8.7386 9.3302 8.5875 9.4015 8.2443 9.6162 L 6.7248 10.6532 C 6.4753 10.8250 6.3384 11.0111 6.3384 11.2258 C 6.3384 11.5547 6.6451 11.8550 7.0583 11.8550 C 7.2380 11.8550 7.3319 11.8264 7.5258 11.6974 L 8.3886 11.0968 L 8.3886 16.4952 C 8.3886 16.8592 8.6381 17.1881 9.0167 17.1881 Z M 14.1194 17.3028 C 15.7865 17.3028 16.8855 16.2373 16.8855 14.6191 C 16.8855 13.1425 15.9429 12.0199 14.2758 12.0199 C 13.8626 12.0199 13.2191 12.3631 12.9553 12.8037 L 13.1265 10.6532 L 16.0859 10.6532 C 16.4276 10.6532 16.6771 10.3673 16.6771 10.0527 C 16.6771 9.7381 16.4276 9.4658 16.0859 9.4658 L 12.8944 9.4658 C 12.3540 9.4658 12.0694 9.7667 12.0123 10.3244 L 11.7342 13.2266 C 11.6771 13.7100 12.0123 13.9962 12.3968 13.9962 C 12.6891 13.9962 12.8116 13.9390 13.0830 13.6956 C 13.4976 13.2837 13.7757 13.1282 14.1337 13.1282 C 15.1038 13.1282 15.6299 13.8026 15.6299 14.6334 C 15.6299 15.4928 15.0038 16.2230 14.1337 16.2230 C 13.5219 16.2230 13.0830 15.8798 12.8116 15.3792 C 12.6547 15.0932 12.4322 14.9663 12.1827 14.9663 C 11.8553 14.9663 11.6485 15.1789 11.6485 15.4793 C 11.6485 15.5936 11.6770 15.6937 11.7199 15.7938 C 12.0266 16.5240 12.9124 17.3028 14.1194 17.3028 Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VidstackAudioPlayer;